import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  ApplicationSaveDto,
  IPrizeClaimSaveDto,
  WinnerListItem,
} from '@app/models';
import { environment } from '../../environments/environment';
import { concatMap, Observable, throwError, timeout } from 'rxjs';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { RewardTag } from '@app/models/reward-tag';
import { map } from 'rxjs/operators';
import { sortBy } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private readonly _httpClient = inject(HttpClient);
  private readonly _recaptchaV3Service = inject(ReCaptchaV3Service);

  /**
   * Submit Foxy club form
   * @param dto
   */
  public submit(dto: ApplicationSaveDto): Observable<{
    detail: string;
    nagroda: {
      tag: RewardTag;
      wartosc: number;
    };
    status: string;
    token: string;
  }> {
    const formData = new FormData();
    formData.append('imie', dto.firstname);
    formData.append('nazwisko', dto.lastname);
    formData.append('telefon', dto.mobile);
    formData.append('email', dto.email);
    formData.append('oswiadczenie', dto.consentAdult ? '1' : '0');
    formData.append('regulamin', dto.consentRegulations ? '1' : '0');
    formData.append('zgodadane', dto.consentClause ? '1' : '0');
    formData.append('komunikacja', dto.consentCommunication ? '1' : '0');
    formData.append('klauzula', dto.consentExclusion ? '1' : '0');
    formData.append('nr_paragonu', dto.proofOfPurchaseNumber);
    formData.append('data_paragonu', dto.dateOfPurchase);
    formData.append('plik_paragonu', dto.imageOfPurchase);
    formData.append('nip', dto.nip);
    return this._recaptchaV3Service.execute('importantAction').pipe(
      timeout({ first: 5000, with: () => throwError(() => 'timeout') }),
      concatMap((recaptcha: string) => {
        formData.append('recaptcha', recaptcha);
        return this._httpClient.post<{
          detail: string;
          nagroda: {
            tag: RewardTag;
            wartosc: number;
          };
          status: string;
          token: string;
        }>(`${environment.api}/zgloszenie`, formData);
      }),
    );
  }

  /**
   * Submit prize claim form
   * @param dto
   */
  public submitPrizeClaim(dto: IPrizeClaimSaveDto): Observable<unknown> {
    return this._recaptchaV3Service.execute('importantAction').pipe(
      timeout({ first: 5000, with: () => throwError(() => 'timeout') }),
      concatMap((recaptcha: string) =>
        this._httpClient.post<unknown>(`${environment.api}/potwierdzenie`, {
          ...dto,
          recaptcha,
        }),
      ),
    );
  }
  // laureaci
  public getWinners(): Observable<WinnerListItem[]> {
    // if (environment.development) {
    //   const _chance = chance.Chance();
    //   const buildTestData = (
    //     tydzien: string,
    //     dzien: string,
    //     type: RewardType,
    //   ) => {
    //     const getName = (rewardType: RewardType): string => {
    //       switch (rewardType) {
    //         case '1000':
    //           return 'Główna nagroda 1 000 zł';
    //         case '500':
    //           return '500 zł';
    //         case '200':
    //           return '200 zł';
    //         case '100':
    //           return '100 zł';
    //         default:
    //           return '';
    //       }
    //     };
    //     return {
    //       tydzien,
    //       dzien,
    //       nazwa: getName(type),
    //       imie: _chance.first(),
    //       tel: _chance.string({ length: 3, pool: '0123456789' }),
    //     };
    //   };
    //
    //   return of([
    //     buildTestData('1', '2024-04-15', '1000'),
    //     buildTestData('1', '2024-04-15', '500'),
    //     buildTestData('1', '2024-04-15', '200'),
    //     buildTestData('1', '2024-04-15', '200'),
    //     buildTestData('1', '2024-04-15', '200'),
    //     buildTestData('1', '2024-04-15', '200'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('1', '2024-04-15', '100'),
    //     buildTestData('2', '2024-04-16', '1000'),
    //     buildTestData('2', '2024-04-16', '500'),
    //     buildTestData('2', '2024-04-16', '200'),
    //     buildTestData('2', '2024-04-16', '200'),
    //     buildTestData('2', '2024-04-16', '200'),
    //     buildTestData('2', '2024-04-16', '200'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //     buildTestData('2', '2024-04-16', '100'),
    //   ]);
    // }

    return this._httpClient
      .get<WinnerListItem[]>(`${environment.api}/laureaci`)
      .pipe(
        map((res: WinnerListItem[]) => {
          res = res.map((item: WinnerListItem): WinnerListItem => {
            // extract number from nazwa field for example get 1000 from "Czek BLIK 1000 zł"
            const value = item.nazwa.match(/(\d+)\s*zł/i)?.[1];
            return {
              ...item,
              value: value ? Number(value) : 0,
            };
          });

          // sort by dzien and nazwa descending
          return sortBy(res, ['dzien', 'value']).reverse();
        }),
      );
  }
}
